import Alert, { type AlertProps } from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';

type Props = {
  message: string;
  onClose?: () => void;
  severity?: AlertProps['severity'];
};

const FormGlobalError = ({ message, onClose, severity = 'error' }: Props) => (
  <Collapse in={!!message} unmountOnExit>
    <Alert severity={severity} onClose={onClose} role="alert" sx={{ alignItems: 'center' }}>
      {message}
    </Alert>
  </Collapse>
);

export default FormGlobalError;
